/*
 * Testimonial slider init. Bundled together with the bxSlider library itself
 * (see gulpfile.js) so this code always runs immediately after bxSlider
 * registers, in the same file -- no need to wait on a separate script tag.
 */

jQuery(function($) {
  if ( ! $('.testimonial--slider').length ) {
    return;
  }

  if ( typeof $.fn.bxSlider !== 'function' ) {
    console.error( '[WNI] testimonial--slider: bxSlider plugin was not registered. Check that jquery.bxslider.js loaded and executed without errors.' );
    return;
  }

  $('.testimonial--slider').bxSlider({
    auto: true,
    autoControls: false,
    controls: false,
    pager: true,
    pause: 8000
  });
});
